import DtoPiezoMeasureLight from '../../piezometry/dto/chart/DtoPiezoMeasureLight'

export default class DtoProductionUnitAssociationsMeasures {
    constructor(obj) {
        this.piezometerId = obj.piezometerId
        this.measures = obj.measures.map(m => new DtoPiezoMeasureLight(m))
    }
}